import { call, put, takeEvery } from 'redux-saga/effects';
import * as actions from './reference-data-actions';
import * as Apis from './reference-data-api';

export function* getChangeRequestReasonTypes(action) {
  try {
    const response = yield call(Apis.getChangeRequestReasonTypes, action.payload);
    yield put(actions.getChangeRequestReasonTypesSuccess(response));
  } catch (error) {
    yield put(actions.getChangeRequestReasonTypesFailure(error));
  }
}

export function* watchGetChangeRequestReasonTypesSaga() {
  yield takeEvery(actions.GET_CHANGE_REQUESET_REASON_TYPES.REQUEST, getChangeRequestReasonTypes);
}
